import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/ramadan.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import MainCalculatorsList from './MainCalculators';
import moment from 'moment-hijri';

const TITLE = "Décompte jusqu'au Ramadan 2027 - Jours restants jusqu'au Ramadan 2027";
const DESCRIPTION = "Combien de jours restants jusqu'au Ramadan 2027 ? Le décompte jusqu'au mois béni du Ramadan 1449 AH vous fournit des informations précises sur la date de début du Ramadan, combien de jours restent jusqu'au Ramadan, et le nombre de jours restants jusqu'à l'arrivée du mois sacré.";
const KEYWORDS = "Ramadan 2027, combien de jours jusqu'au Ramadan 2027, décompte Ramadan, date Ramadan 2027";
const OG_URL = "https://do-calculate.com/articles-fr/ramadan";

function Ramadan() {
    const [ramadanDates, setRamadanDates] = useState([
        { name: 'Ramadan 2026', date: new Date("2026-02-18T00:00:00") },
        { name: 'Ramadan 2027', date: new Date("2027-02-08T00:00:00") },
        { name: 'Ramadan 2028', date: new Date("2028-01-28T00:00:00") },
        { name: 'Ramadan 2029', date: new Date("2029-01-16T00:00:00") },
    ]);

    const nextRamadan = ramadanDates.find(d => new Date() < d.date) || ramadanDates[ramadanDates.length - 1];
    const dayName = nextRamadan.date.toLocaleDateString('fr-FR', { weekday: 'long' });

    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextRamadan.date));

    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextRamadan.date));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextRamadan]);

    return (
        <div className="ltr">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className="p-3 mb-2 bg-success text-white">
                Décompte jusqu'au Ramadan {nextRamadan.name.split(' ')[1]}
            </h1>
            <div>
                <BlinkingText
                    text={`Décompte jusqu'au Ramadan : le mois du Ramadan ${nextRamadan.name.split(' ')[1]} devrait commencer le ${dayName} ${nextRamadan.date.toLocaleDateString('fr-FR')} (grégorien) et le ${moment(nextRamadan.date).format('iDD/iMM/iYYYY')} (hégirien).`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th className="bmi-header">Jours</th>
                                <th className="bmi-header">Heures</th>
                                <th className="bmi-header">Minutes</th>
                                <th className="bmi-header">Secondes</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days ?? 0}</td>
                                <td>{timeLeft.hours ?? 0}</td>
                                <td>{timeLeft.minutes ?? 0}</td>
                                <td>{timeLeft.seconds ?? 0}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className="p-3 mb-2 bg-success text-white" style={{ fontSize: '28px', textAlign: 'center' }}>
                            Prochaines dates du Ramadan
                        </h2>
                        <table style={{ fontSize: '20px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Ramadan</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Jours restants</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ramadanDates.map((ramadan, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{ramadan.name}</td>
                                        <td style={{ padding: '12px' }}>{ramadan.date.toLocaleDateString('fr-FR')}</td>
                                        <td style={{ padding: '12px' }}>
                                            {Math.max(0, calculateTimeLeft(ramadan.date).days ?? 0)} jours
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-sm-4 col-md-4">
                    <MainCalculatorsList />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className="p-3 mb-2 bg-success text-white">Décompte jusqu'au Ramadan 2027</h3>
                    <p>
                        Dans cet article, nous vous proposons un décompte détaillé jusqu'au mois béni du Ramadan, afin que vous puissiez être informé à tout moment du nombre de jours restants jusqu'à l'arrivée de ce mois noble. Beaucoup d'entre nous se demandent combien de temps reste jusqu'au mois béni du Ramadan. C'est pourquoi, dans cet article, nous vous présentons le décompte jusqu'au mois béni du Ramadan, vous permettant de savoir combien de temps reste jusqu'au Ramadan, combien de jours restent, et quand commence le Ramadan.
                    </p>
                    <p>
                        Selon le calendrier hégirien, le Ramadan 2027 devrait commencer le {dayName} {nextRamadan.date.toLocaleDateString('fr-FR')} (grégorien) et {moment(nextRamadan.date).format('iDD/iMM/iYYYY')} (hégirien). Vous pouvez voir le décompte jusqu'au Ramadan dans cet article.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Calculer les jours restants jusqu'au mois sacré du Ramadan
                    </h3>
                    <p>
                        Grâce au programme de décompte du Ramadan, vous pouvez savoir combien de jours restent jusqu'au Ramadan dans les calendriers grégorien et hégirien. Vous pouvez également découvrir combien de jours restent jusqu'au Ramadan et combien de jours restent jusqu'à la fin du Ramadan, et quand commence le Ramadan.
                    </p>
                    <h3 className="p-3 mb-2 bg-success text-white">Le Ramadan</h3>
                    <p>
                        Le Ramadan, neuvième mois du calendrier hégirien, suit immédiatement le mois de Sha'ban et se distingue par son statut particulier dans le cœur des musulmans. C'est le mois du jeûne, l'un des piliers de l'Islam, pendant lequel les musulmans s'abstiennent de nourriture, de boisson et de désirs, de l'aube jusqu'au coucher du soleil. Le mois de Ramadan commence avec l'observation du croissant de lune le 29e jour de Sha'ban, et si le croissant n'est pas vu, Sha'ban compte 30 jours et le lendemain sera le premier jour du Ramadan.
                    </p>
                    <p>
                        Les musulmans célèbrent l'Aïd al-Fitr à la fin du Ramadan, et le Ramadan occupe une place particulière dans l'histoire et le patrimoine islamiques, car le Coran a été révélé pendant la Nuit du Destin (Laylat al-Qadr) dans ce mois noble.
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Décompte jusqu'au Ramadan" style={{ width: '100%', height: 'auto' }} />
                    </div>
                    <h3 className="p-3 mb-2 bg-success text-white">
                        Les bienfaits du jeûne pendant le Ramadan
                    </h3>
                    <p>
                        Le jeûne pendant le mois de Ramadan présente de nombreux bienfaits pour la personne qui jeûne, englobant tous les aspects physiques et psychologiques. Ces nombreux bienfaits incluent : l'amélioration des niveaux sanguins, la réduction des lipides nocifs dans le sang, la régulation de la tension artérielle, le maintien du taux de glycémie, la réduction du stress et de l'anxiété, et la lutte contre le cancer et l'inflammation.
                    </p>
                    <ul>
                        <li>Amélioration des niveaux sanguins</li>
                        <li>Réduction des lipides nocifs dans le sang</li>
                        <li>Régulation de la tension artérielle</li>
                        <li>Maintien du taux de glycémie</li>
                        <li>Lutte contre le cancer et l'inflammation</li>
                        <li>Amélioration de la digestion et du système digestif</li>
                        <li>Renforcement des fonctions mentales et cognitives</li>
                        <li>Renforcement du système immunitaire</li>
                        <li>Amélioration de la santé cardiaque</li>
                        <li>Détoxification du corps</li>
                    </ul>
                </div>
            </div>
            <MobileUnderCalAds />
        </div>
    );
}

export default Ramadan;
